module.exports = __webpack_public_path__ + "static/media/r_dot_8.7bdbc4bd.png";